import { render, staticRenderFns } from "./DetailInternalQuotations.vue?vue&type=template&id=229f6f4e&scoped=true&lang=pug"
import script from "./DetailInternalQuotations.vue?vue&type=script&lang=js"
export * from "./DetailInternalQuotations.vue?vue&type=script&lang=js"
import style0 from "./DetailInternalQuotations.vue?vue&type=style&index=0&id=229f6f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f6f4e",
  null
  
)

export default component.exports